import React from "react";
import { Table } from "antd";

const CustomTable = ({
  title,
  columns,
  data,
  loading,
  className,
  showPagination,
  onPageChange,
  total,
  ...props
}) => {
  return (
    <div className="custom-table shadow px-2">
      <h3>{title}</h3>
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        className={className}
        pagination={{
          total: total,
          showSizeChanger: true,
          showQuickJumper: true,
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} of ${total} items`,
          onChange: onPageChange,
          onShowSizeChange: onPageChange,
        }}
        {...props}
      />
    </div>
  );
};

export default CustomTable;
